import { combineReducers } from '@reduxjs/toolkit';

import authReducer from './auth/slice';
import mapFeaturesReducer from './map_features/slice';

const reducers = combineReducers({
	auth: authReducer,
	mapFeatures: mapFeaturesReducer
});

export default reducers;
